import React, { useState } from 'react';

const ReviewSelection = () => {
  const [selectedPayment, setSelectedPayment] = useState('credit');
  const [selectedTab, setSelectedTab] = useState('SFO-LAX'); // For flight tab selection
  const [tripType] = useState('roundTrip'); // You can make this dynamic based on booking data
  
  return (
    <div className="min-h-screen bg-white">
      <main id="aa-content-frame">
        <div className="max-w-[1240px] mx-auto px-4 py-6">
          
          {/* Page Header */}
          <div className="flex justify-between items-start ">
            <div>
              <h1 className="text-[44px] mt-7 font-bold leading-[48px] text-[#181e25]" style={{fontFamily: 'AmericanSans Var, Arial, sans-serif'}}>
                Review and pay
              </h1>
            </div>
            <div>
              <h2 className="text-[38px]   leading-[48px] text-[#181e25]" style={{fontFamily: 'AmericanSans Var, Arial, sans-serif' , position: 'relative', top: '20px' , right:'220px'}}>
                Your trip
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            
            {/* Left Column - Payment Options and Rules */}
            <div className="lg:col-span-2">
              
              {/* How would you like to pay? */}
              <div className="mb-8 mt-8">
                <h2 className="text-4xl   text-[#181e25] mb-6">How would you like to pay?</h2>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  
                  {/* Add Trip Credit / Flight Credit */}
                  <div className="border border-gray-300 rounded-lg p-4 hover:bg-gray-50 cursor-pointer">
                    <div className="flex justify-between items-start mb-2">
                      <div className="w-8 h-8 text-blue-600">
                        ✈️
                      </div>
                      <div className="text-blue-600">
                        →
                      </div>
                    </div>
                    <div className="font-medium text-gray-900">Add Trip Credit / Flight Credit</div>
                  </div>

                  {/* Add a gift card / flight discount */}
                  <div className="bg-blue-50 border border-blue-300 rounded-lg p-4 hover:bg-blue-100 cursor-pointer">
                    <div className="flex justify-between items-start mb-2">
                      <div className="w-8 h-8 text-blue-600">
                        🎁
                      </div>
                      <div className="text-blue-600">
                        →
                      </div>
                    </div>
                    <div className="font-medium text-gray-900">Add a gift card / flight discount</div>
                  </div>
                </div>

                {/* Additional Benefits Info */}
                <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 text-blue-600 mr-3 mt-1">
                      ℹ️
                    </div>
                    <div className="text-sm text-gray-700">
                      <strong>Earn additional miles and Loyalty Points on this purchase when you use an AAdvantage® credit card.</strong><br/>
                      Review your Aviator® Reward Rules or Citi®/AAdvantage® Directory of Services for details.
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="mb-8">
                
                {/* Credit/Debit Card */}
                <div className="mb-4">
                  <div 
                    className={`p-4 cursor-pointer ${selectedPayment === 'credit' ? 'bg-blue-50 border-blue-300' : ''}`}
                    onClick={() => setSelectedPayment('credit')}
                  >
                    <div className="flex items-center">
                      <input 
                        type="radio" 
                        name="payment" 
                        value="credit"
                        checked={selectedPayment === 'credit'}
                        onChange={() => setSelectedPayment('credit')}
                        className="mr-4"
                      />
                      <div>
                        <div className="font-medium text-gray-900 mb-2">Credit / debit card</div>
                        <div className="flex space-x-2">
                          <img src="./citi-advantage.jpg" alt="Visa" className="w-10 h-6" />
                          <img src="./barclay-advantage.jpg" alt="Mastercard" className="w-10 h-6" />
                          <img src="./masterCard.jpg" alt="American Express" className="w-10 h-6" />
                          <img src="./visa.jpg" alt="Discover" className="w-10 h-6" />
                          <img src="./discover.jpg" alt="JCB" className="w-10 h-6" />
                          <img src="./uatp.jpg" alt="JCB" className="w-10 h-6" />
                          <img src="./diners.jpg" alt="JCB" className="w-10 h-6" />
                          <img src="./jcb.jpg" alt="JCB" className="w-10 h-6" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pay over time with Affirm */}
                <div className=" mb-4">
                  <div 
                    className={`p-4 cursor-pointer ${selectedPayment === 'affirm' ? 'bg-blue-50 border-blue-300' : ''}`}
                    onClick={() => setSelectedPayment('affirm')}
                  >
                    <div className="flex items-center">
                      <input 
                        type="radio" 
                        name="payment" 
                        value="affirm"
                        checked={selectedPayment === 'affirm'}
                        onChange={() => setSelectedPayment('affirm')}
                        className="mr-4"
                      />
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 text-blue-600 mr-4">
                        <svg width="47" height="30" viewBox="0 0 47 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.500488" width="46" height="29" rx="3.5" fill="white" stroke="#B4C1CF"></rect>
                <path d="M44.0269 6.00049H5.02686V21.8845H44.0269V6.00049Z" fill="white"></path>
                <mask id="mask0_7903_256535" maskUnits="userSpaceOnUse" x="5" y="14" width="6" height="7">
                    <path d="M5.02686 14.4487H10.9661V21H5.02686V14.4487Z" fill="white"></path>
                </mask>
                <g mask="url(#mask0_7903_256535)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5752 19.7079C7.09448 19.7079 6.85498 19.4796 6.85498 19.1021C6.85498 18.4037 7.66307 18.1646 9.13797 18.0137C9.13797 18.9479 8.48495 19.7079 7.5752 19.7079ZM8.21099 14.4487C7.15736 14.4487 5.94436 14.9296 5.28617 15.4371L5.8875 16.6612C6.41561 16.1937 7.26936 15.7946 8.03955 15.7946C8.77097 15.7946 9.17502 16.0312 9.17502 16.5071C9.17502 16.8287 8.90709 16.9904 8.40052 17.0537C6.51037 17.2921 5.02686 17.7962 5.02686 19.2062C5.02686 20.3237 5.8496 21.0004 7.13497 21.0004C8.05161 21.0004 8.86832 20.5071 9.25686 19.8562V20.8179H10.9661V16.7887C10.9661 15.1246 9.77032 14.4487 8.21099 14.4487Z" fill="#181E25"></path>
                </g>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.376 14.6319V20.8194H27.2058V17.8385C27.2058 16.421 28.0923 16.0052 28.7109 16.0052C28.9521 16.0052 29.2777 16.0727 29.4931 16.2285L29.8265 14.5927C29.544 14.476 29.2485 14.4502 29.0064 14.4502C28.0656 14.4502 27.4746 14.8535 27.0843 15.6719V14.6319H25.376Z" fill="#181E25"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M38.3073 14.4497C37.3398 14.4497 36.617 15.003 36.2405 15.5364C35.8908 14.8472 35.1499 14.4497 34.2634 14.4497C33.2959 14.4497 32.6265 14.9697 32.3172 15.5672V14.6314H30.5537V20.8189H32.3844V17.6339C32.3844 16.4897 33.003 15.9422 33.5811 15.9422C34.104 15.9422 34.5847 16.2697 34.5847 17.1139V20.8189H36.4128V17.6339C36.4128 16.4772 37.0176 15.9422 37.6224 15.9422C38.1057 15.9422 38.6157 16.2822 38.6157 17.1014V20.8189H40.4438V16.5422C40.4438 15.1514 39.4764 14.4497 38.3073 14.4497Z" fill="#181E25"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.922 14.6309H19.2645V14.0018C19.2645 13.1834 19.7478 12.9493 20.1648 12.9493C20.6248 12.9493 20.9832 13.1468 20.9832 13.1468L21.5475 11.8993C21.5475 11.8993 20.9755 11.5376 19.9356 11.5376C18.7666 11.5376 17.4364 12.1751 17.4364 14.1759V14.6309H14.6615V14.0018C14.6615 13.1834 15.1448 12.9493 15.5609 12.9493C15.7978 12.9493 16.1166 13.0026 16.3802 13.1468L16.9445 11.8993C16.6076 11.7076 16.0666 11.5376 15.3326 11.5376C14.1635 11.5376 12.8334 12.1751 12.8334 14.1759V14.6309H11.772V15.9959H12.8334V20.8184H14.6615V15.9959H17.4364V20.8184H19.2645V15.9959H20.922V14.6309Z" fill="#181E25"></path>
                <mask id="mask1_7903_256535" maskUnits="userSpaceOnUse" x="4" y="6" width="41" height="16">
                    <path d="M4 21.0005H44.0263V6.00049H4V21.0005Z" fill="white"></path>
                </mask>
                <g mask="url(#mask1_7903_256535)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0132 20.8184H23.8396V14.6309H22.0132V20.8184Z" fill="#181E25"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M32.6689 6.00049C27.7307 6.00049 23.3293 9.31632 22.0801 13.5797H23.8703C24.9136 10.4047 28.4552 7.61799 32.6689 7.61799C37.7905 7.61799 42.217 11.3897 42.217 17.2613C42.217 18.5797 42.0404 19.768 41.7061 20.818H43.4429L43.4601 20.7605C43.7444 19.6772 43.8892 18.5005 43.8892 17.2613C43.8892 10.713 38.9562 6.00049 32.6689 6.00049Z" fill="#0860C4"></path>
                </g>
            </svg>
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">Pay over time with Affirm -</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PayPal */}
                <div className=" mb-4">
                  <div 
                    className={`p-4 cursor-pointer ${selectedPayment === 'paypal' ? 'bg-blue-50 border-blue-300' : ''}`}
                    onClick={() => setSelectedPayment('paypal')}
                  >
                    <div className="flex items-center">
                      <input 
                        type="radio" 
                        name="payment" 
                        value="paypal"
                        checked={selectedPayment === 'paypal'}
                        onChange={() => setSelectedPayment('paypal')}
                        className="mr-4"
                      />
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 text-blue-600 mr-4">
                        <svg width="47" height="30" viewBox="0 0 47 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.500488" width="46" height="29.0005" rx="3.5" fill="white" stroke="#D1D9E0"></rect>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2018 23.0612L20.5069 21.2498L19.8272 21.235H16.5815L18.8372 7.86774C18.8442 7.82726 18.8669 7.78968 18.9001 7.76295C18.9334 7.73622 18.9759 7.72156 19.0204 7.72156H24.4931C26.3101 7.72156 27.5639 8.07486 28.2184 8.7723C28.5253 9.09948 28.7208 9.44147 28.8154 9.81769C28.9146 10.2125 28.9163 10.6842 28.8195 11.2596L28.8125 11.3015V11.6702L29.1194 11.8327C29.3778 11.9609 29.5832 12.1075 29.7407 12.2754C30.0032 12.5552 30.173 12.9108 30.2448 13.3322C30.319 13.7657 30.2944 14.2817 30.173 14.8658C30.033 15.5376 29.8066 16.1227 29.5008 16.6014C29.2197 17.0426 28.8615 17.4085 28.4361 17.692C28.03 17.9615 27.5475 18.166 27.002 18.2969C26.4733 18.4255 25.8706 18.4904 25.2095 18.4904H24.7837C24.4792 18.4904 24.1834 18.5929 23.9512 18.7767C23.7183 18.9643 23.5643 19.2206 23.5171 19.5008L23.4849 19.664L22.9457 22.8568L22.9214 22.974C22.9149 23.0111 22.9037 23.0296 22.8874 23.0421C22.8729 23.0536 22.8519 23.0612 22.8315 23.0612H20.2018Z" fill="#043062"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M29.4104 11.344C29.3943 11.4416 29.3755 11.5413 29.3545 11.6438C28.6328 15.1072 26.1636 16.3036 23.0101 16.3036H21.4044C21.0187 16.3036 20.6937 16.5653 20.6337 16.9209L19.5788 23.1751C19.5397 23.4086 19.7322 23.6189 19.9842 23.6189H22.8321C23.1693 23.6189 23.4558 23.39 23.5089 23.0791L23.5368 22.944L24.073 19.7636L24.1075 19.5892C24.16 19.2773 24.4471 19.0482 24.7843 19.0482H25.2102C27.9693 19.0482 30.1294 18.0013 30.7607 14.9714C31.0243 13.7057 30.8878 12.6489 30.19 11.9056C29.9788 11.6816 29.7169 11.4955 29.4104 11.344Z" fill="#298FC2"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M28.6552 11.0627C28.5448 11.0326 28.4311 11.0054 28.3144 10.9808C28.1971 10.9568 28.077 10.9356 27.9532 10.9169C27.5203 10.8516 27.0459 10.8206 26.5378 10.8206H22.2483C22.1426 10.8206 22.0422 10.8429 21.9525 10.8832C21.7546 10.9721 21.6077 11.1471 21.572 11.3614L20.6594 16.7634L20.6333 16.9209C20.6933 16.5653 21.0183 16.3037 21.404 16.3037H23.0097C26.1632 16.3037 28.6324 15.1066 29.3541 11.6439C29.3757 11.5414 29.3939 11.4416 29.41 11.344C29.2275 11.2534 29.0297 11.176 28.8168 11.11C28.7642 11.0937 28.7099 11.0779 28.6552 11.0627Z" fill="#22284F"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5722 11.3615C21.6078 11.1472 21.7547 10.9721 21.9526 10.8838C22.043 10.8433 22.1427 10.821 22.2484 10.821H26.5379C27.046 10.821 27.5205 10.8522 27.9534 10.9176C28.0771 10.9361 28.1972 10.9574 28.3146 10.9814C28.4312 11.0059 28.545 11.0332 28.6553 11.0631C28.71 11.0784 28.7643 11.0943 28.8174 11.11C29.0304 11.176 29.2283 11.2541 29.4108 11.344C29.6256 10.0642 29.409 9.19277 28.6687 8.40369C27.8524 7.53487 26.3792 7.16309 24.4941 7.16309H19.0212C18.6362 7.16309 18.3077 7.42474 18.2482 7.78094L15.9687 21.2856C15.9238 21.5528 16.1442 21.7938 16.4325 21.7938H19.8112L21.5722 11.3615Z" fill="#043062"></path>
            </svg>
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">PayPal</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Hold for 24 hours */}
                <div className=" mb-4">
                  <div 
                    className={`p-4 cursor-pointer ${selectedPayment === 'hold' ? 'bg-blue-50 border-blue-300' : ''}`}
                    onClick={() => setSelectedPayment('hold')}
                  >
                    <div className="flex items-center">
                      <input 
                        type="radio" 
                        name="payment" 
                        value="hold"
                        checked={selectedPayment === 'hold'}
                        onChange={() => setSelectedPayment('hold')}
                        className="mr-4"
                      />
                      <div className="flex items-center">
                        <div className="w-8 h-8 text-blue-600 mr-4">
                          🕐
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">Hold for 24 hours -</div>
                          <div className="text-sm text-gray-600">Need more time to decide? Put your flight on hold, free of charge.</div>
                          <a href="#" className="text-blue-600 hover:underline text-sm">24-hour hold policy ↗</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Fare rules */}
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Fare rules</h3>
                <div className="space-y-3 text-sm text-gray-700">
                  <div className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>You have 24 hours from the time you first buy your ticket to make changes or cancel for a refund if you booked at least 2 days before departure. <a href="#" className="text-blue-600 hover:underline">Refund policy ↗</a></span>
                  </div>
                  <div className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>We may give the government your information to comply with federal security regulations.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Optional service fees include bags, seats and upgrades. <a href="#" className="text-blue-600 hover:underline">Optional service fees ↗</a></span>
                  </div>
                </div>
                <div className="mt-4">
                  <a href="#" className="text-blue-600 hover:underline text-sm">Detailed fare rules ↗</a>
                </div>
              </div>

              {/* Additional Info */}
              <div className="text-sm text-gray-600 mb-8">
                American Airlines is a U.S. merchant. Your bank may apply conversion or foreign transaction fees.
              </div>

              <div className="text-right">
                <a href="#" className="text-blue-600 hover:underline">Reservation and tickets FAQs ↗</a>
              </div>
            </div>

            {/* Right Column - Trip Summary */}
            <div className="lg:col-span-1">
              
              {/* Flight Selection Options - Outside the box */}
              <div className="mb-6">
                <div className={`flex ${tripType === 'roundTrip' ? 'w-full' : 'w-full'}`}>
                  {/* SFO - LAX Option */}
                  <button
                    className={`px-6 py-4 text-lg font-medium border-b-2 transition-colors flex-1 ${
                      selectedTab === 'SFO-LAX'
                        ? 'border-blue-600 text-blue-600'
                        : 'border-gray-300 text-gray-500 hover:text-gray-700'
                    }`}
                    onClick={() => setSelectedTab('SFO-LAX')}
                  >
                    SFO - LAX
                  </button>
                  
                  {/* LAX - SFO Option (only show for round trip) */}
                  {tripType === 'roundTrip' && (
                    <button
                      className={`px-6 py-4 text-lg font-medium border-b-2 transition-colors flex-1 ${
                        selectedTab === 'LAX-SFO'
                          ? 'border-blue-600 text-blue-600'
                          : 'border-gray-300 text-gray-500 hover:text-gray-700'
                      }`}
                      onClick={() => setSelectedTab('LAX-SFO')}
                    >
                      LAX - SFO
                    </button>
                  )}
                </div>
              </div>
              
              {/* Trip Details Box */}
              <div className="bg-white border border-gray-300 rounded-lg overflow-hidden mb-4">
                {selectedTab === 'SFO-LAX' ? (
                  // SFO to LAX Flight Details
                  <>
                    <div className="p-4">
                      <div className="text-base font-medium text-gray-900 mb-2">
                        Tuesday, September 16, 2025
                      </div>
                      
                      <div className="flex items-center justify-between ">
                        <div className="text-left">
                          <div className="text-base font-medium">10:15 AM</div>
                        </div>
                        <div className="text-center">
                          <div className="text-sm text-gray-600">1h 31m</div>
                        </div>
                        <div className="text-right">
                          <div className="text-base font-medium">11:46 AM</div>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between text-lg font-bold mb-2">
                        <span>SFO</span>
                        
                        <div className="text-gray-400">✈</div>
                        <span>LAX</span>
                      </div>
                      
                      <div className="flex justify-between text-sm text-gray-600 ">
                        <span>San Francisco, CA</span>
                        <span>Los Angeles, CA</span>
                      </div>
                    </div>
                    
                    {/* Footer */}
                    <div className="border-t border-gray-200 px-6 py-4 bg-gray-50">
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-900">AA 4994 • Main Cabin</span>
                        <button className="text-blue-600 hover:text-blue-800 transition-colors">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M6 9l6 6 6-6"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  // LAX to SFO Flight Details (Return flight)
                  <>
                    <div className="p-6">
                      <div className="text-base font-medium text-gray-900 mb-4">
                        Friday, September 19, 2025
                      </div>
                      
                      <div className="flex items-center justify-between mb-4">
                        <div className="text-left">
                          <div className="text-base font-medium">2:30 PM</div>
                        </div>
                        <div className="text-center">
                          <div className="text-sm text-gray-600">1h 28m</div>
                        </div>
                        <div className="text-right">
                          <div className="text-base font-medium">3:58 PM</div>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between text-lg font-bold mb-2">
                        <span>LAX</span>
                        <div className="text-gray-400">✈</div>
                        <span>SFO</span>
                      </div>
                      
                      <div className="flex justify-between text-sm text-gray-600 mb-4">
                        <span>Los Angeles, CA</span>
                        <span>San Francisco, CA</span>
                      </div>
                    </div>
                    
                    {/* Footer */}
                    <div className="border-t border-gray-200 px-6 py-4 bg-gray-50">
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-900">AA 1247 • Main Cabin</span>
                        <button className="text-blue-600 hover:text-blue-800 transition-colors">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M6 9l6 6 6-6"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Cost summary */}
              <div className="bg-white border border-gray-300 rounded-lg p-6 mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Cost summary</h3>
                
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700">Main Plus/Main × 1</span>
                    <span className="font-medium">$334.30</span>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <a href="#" className="text-blue-600 hover:underline text-sm">Taxes and carrier imposed fees ↗</a>
                    <span className="font-medium">$55.67</span>
                  </div>
                  
                  <div className="border-t border-gray-200 pt-3">
                    <div className="flex justify-between items-center font-medium">
                      <span>Total fare</span>
                      <span>$389.97</span>
                    </div>
                  </div>
                </div>

                <div className="mt-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-3">Extras</h4>
                  
                  <div className="space-y-2">
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-gray-700">Main Cabin Extra × 1</span>
                      <span className="font-medium">$38.96</span>
                    </div>
                    
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-gray-700">Preferred Seat × 1</span>
                      <span className="font-medium">$0.00</span>
                    </div>
                  </div>
                  
                  <div className="border-t border-gray-200 pt-3 mt-3">
                    <div className="flex justify-between items-center font-medium">
                      <span>Total extras</span>
                      <span>$38.96</span>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-300 pt-4 mt-6">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="font-bold text-xl">Total amount due</div>
                      <div className="text-sm text-gray-600">(All passengers)</div>
                    </div>
                    <div className="text-2xl font-bold">$428.93</div>
                  </div>
                </div>
              </div>

              {/* Credit Card Offer */}
              <div className="bg-gray-100 border border-gray-300 rounded-lg overflow-hidden">
                <div className="p-6">
                  <div className="flex justify-center mb-4">
                    <img 
                      src="./hero-card-platinum.png"
                      alt="AAdvantage Credit Card" 
                      className="w-48 h-30 transform -rotate-12"
                    />
                  </div>
                  
                  <div className="bg-red-600 text-white px-3 py-1 text-xs font-bold rounded mb-3 inline-block">
                    NEW CARDMEMBER OFFER
                  </div>
                  <div className='bg-white border-2 border-grey-600 p-4'>
                  <div className=" ">
                    <div className="text-sm text-gray-600 ">Earn up to a</div>
                    <div className="flex items-baseline ">
                      <span className="text-3xl font-bold">$200</span>
                      <span className="text-2xl mx-2">+</span>
                      <span className="text-3xl font-bold">40,000</span>
                    </div>
                    <div className="flex text-sm text-gray-700">
                      <span className="mr-8">statement credit</span>
                      <span>bonus miles</span>
                    </div>
                  </div>
                  
                  <div className="space-y-2 text-sm ">
                    <div className="flex justify-between">
                      <span>Pay today:</span>
                      <span className="font-medium">$428.93</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Card statement credit:</span>
                      <span className="font-medium">-$200.00</span>
                    </div>
                    <div className="border-t border-gray-400 pt-2 flex justify-between font-medium">
                      <span>Total after statement credit:</span>
                      <span>$228.93</span>
                    </div>
                  </div>
                  </div>
                  <p className="text-sm text-gray-700 mb-4 leading-relaxed">
                    Plus, get your first checked bag free on domestic American Airlines itineraries. Terms apply.
                  </p>
                  
                  <button className="w-full px-4 py-2 border-2 border-blue-600 text-blue-600 rounded hover:bg-blue-50 text-sm font-medium">
                    Learn more ↗
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReviewSelection;